import { Component, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { scopeLoader } from '@libraries/transloco-root';
import { SectionValueAccessor } from '@libraries/ui';

interface Address {
  address: string;
  apn: string;
  city: string;
  display: string;
  fips: string;
  line_2: string;
  owner: string;
  plus4: string;
  state: string;
  zipcode: string;
}

@Component({
  selector: 'multiple-address',
  templateUrl: './multiple-address.component.html',
  styleUrls: ['./multiple-address.component.scss'],
  standalone: false,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      multi: true,
      useValue: {
        scope: 'componentLibrary',
        loader: scopeLoader((lang: string, root: string) => import(`../${root}/${lang}.json`)),
      },
    },
  ],
})
export class MultipleAddressComponent extends SectionValueAccessor<Address> implements OnInit {
  @Input() addressChoices: Address[];

  constructor(public ngControl: NgControl) {
    super(ngControl);
  }

  ngOnInit() {}

  onAddressSelection(address: Address) {
    this.value = address;
  }
}
